export default __webpack_public_path__ + "static/media/chihuasdevs-logo.6341f791.png";